module.exports = __webpack_public_path__ + "assets-cabinet/img/error-checkmark-icon.e911a494.svg";